export default "__VITE_ASSET__Deik16zR__"